import { useTranslation } from "react-i18next";
import '../assets/scss/components/skip-activation.scss';

function SkipCombineFee({ initialValue = false, onChange, disabled = false }) {
  const { t } = useTranslation();
  return (
    <div className="mb-3 skip-activation">
      <input
        type="checkbox"
        checked={initialValue}
        onChange={onChange}
        className="form-check-input"
        id="skip_activation_fee"
        disabled={disabled}
      />
      <label className="mb-0" htmlFor="skip_activation_fee">
        {t("Skip Combine Fee")}
      </label>
    </div>
  );
}

export default SkipCombineFee;
